export default {
  BASE_URL:"https://admin.ziegler-instrument.com",
};
